import { Component, OnInit } from '@angular/core';
import { UserService } from "../../services/user.service";
import { User } from "../../models/user";
import { environment } from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MovimientosComponent } from 'src/app/modales/movimientos/movimientos.component';
declare var $: any;

@Component({
  selector: 'app-cartera',
  templateUrl: './cartera.component.html',
  styleUrls: [
    './cartera.component.css',
    '../login/perfect-scrollbar/dist/css/perfect-scrollbar.min.css',
    '../login/css/table.css',
    '../login/css/estilos.css'
  ],
  providers: [UserService]
})
export class CarteraComponent implements OnInit {
  public user: User;
  public carteraAsociado;
  public cuotasext
  public fechaDia;
  public cartera;
  public identity;
  public token;
  public mvtocarteras;
  public planpagos;
  public mvtopagosfuturos;
  paginaactual: number = 1;
  actual = environment.actual;
  public colorFondo = environment.entidad[this.actual].colorMenu;
  public letraColor = environment.entidad[this.actual].letraColor;
  public carteraConfig
  public mobile
  public estadoPagare

  constructor(
    private _userService: UserService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
  ) {
    this.user = new User(1, '', '', '', '', '', '', 0, 0);
  }

  ngOnInit() {
    this.estadoPagare = null
    this.spinner.show()
    this.identity = JSON.parse(this._userService.GetsessionStorage('identity'));
    this.carteraConfig = JSON.parse(this._userService.GetsessionStorage('config'));
    this.consultCartera()
    if (this.carteraConfig.general.cuotasextra == 'S') {
      this.getCuotasExt()
    }

    if (window.screen.width > 0) {
     this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  llamaHtml(): string {
    let tblAsoc = document.getElementById('tblCart').innerHTML
    return tblAsoc
  }

  decodeBuffer(arraybuffer?) {
    if (arraybuffer != null) {
      return String.fromCharCode.apply(null, new Uint16Array(arraybuffer));
    }
  }

  consultCartera() {
    let date = new Date();
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let data = {
      codasociado: this.identity.CODASOCIADO,
      fhasta: year + '-' + (monthIndex + 1) + '-' + day,
      recoge: false,
      pse: false
    };
    this._userService.httpPost('cartera', data).subscribe(
      response => {
        if (response.status != 'error') {
          this.carteraAsociado = response.details;
        } else {
          console.log(response.details)
        }
        this.spinner.hide()
      },
      error => {
        console.log(<any>error);
        this.spinner.hide()
      }
    );
  }

  getCuotasExt() {
    let date = new Date();
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let data = {
      codasociado: this.identity.CODASOCIADO,
      fhasta: year + '-' + (monthIndex + 1) + '-' + day
    };
    this._userService.httpPost('cuotasext', data).subscribe(
      (response: any) => {
        if (response.status != 'error') {
          this.cuotasext = response.details;
        } else {
          console.log(response.details)
        }
        this.spinner.hide()
      },
      error => {
        console.log(<any>error);
        this.spinner.hide()
      }
    );
  }

  mvtocartera(numpagare) {
    this.spinner.show()
    this.planpagos = '';
    this.mvtopagosfuturos = '';
    this.mvtocarteras = [];
    this.paginaactual = 1;
    this._userService.httpGet('mvtocartera/' + numpagare).subscribe(
      response => {
        //devuelve token
        this.mvtocarteras = response;
        if (!this.mobile) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = false;
          dialogConfig.width = '100%';
          const modalRef = this.dialog.open(MovimientosComponent, {
            autoFocus: false,
            maxHeight: '100%',
            width: '100%', //you can adjust the value as per your view
            data: { datos: this.mvtocarteras, modulo: 'mvtocartera', op: 1 }
          });

          modalRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
          });
        }
        this.spinner.hide()
      },
      error => {
        console.log(<any>error);
        this.spinner.hide()
      }
    );
  }
  plandepagos(pagare) {
    this.spinner.show()
    this.mvtocarteras = '';
    this.mvtopagosfuturos = '';
    this.user.pagare = pagare
    this._userService.httpPost('planPagos', this.user).subscribe(
      response => {
        console.log(response)
        this.planpagos = response;
        if (!this.mobile) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = false;
          dialogConfig.width = '100%';
          const modalRef = this.dialog.open(MovimientosComponent, {
            autoFocus: false,
            maxHeight: '100%',
            width: '100%', //you can adjust the value as per your view
            data: { datos: this.planpagos, modulo: 'planpagos', op: 2 }
          });

          modalRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
          });
        } else {
          this.scrollTOElement('#plandepagos', 300, 500);
        }
        this.spinner.hide()
      },
      error => {
        console.log(<any>error);
        this.spinner.hide()
      }
    );
  }

  pagosfuturos(pagare, fecha) {
    this.spinner.show()
    this.mvtocarteras = '';
    this.planpagos = '';
    this.user.pagare = pagare;
    this.user.fechaAct = fecha
    this._userService.httpPost('pagosFuturos', this.user).subscribe(
      response => {
        //devuelve token
        console.log(response)
        this.mvtopagosfuturos = response;
        if (!this.mobile) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = false;
          dialogConfig.width = '100%';
          const modalRef = this.dialog.open(MovimientosComponent, {
            autoFocus: false,
            maxHeight: '100%',
            width: '100%', //you can adjust the value as per your view
            data: { datos: this.mvtopagosfuturos, modulo: 'pagosfuturos', op: 3 }
          });

          modalRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
          });
        } else {
          this.scrollTOElement('#pagosfuturos', 300, 500);
        }
        this.spinner.hide()
      },
      error => {
        console.log(<any>error);
        this.spinner.hide()
      }
    );
  }

  PrintEstadoPagare(pagare) {
    this.estadoPagare = null
    this.spinner.show()
    this._userService.httpPost('getEstadoPagare', { pagare: pagare }).subscribe(
      resp => {
        console.log(resp)

        const linkSource = `data:application/pdf;base64,${resp.details}`;
        const downloadLink = document.createElement("a");
        const fileName = "EstadoCuenta" + pagare + ".pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this.spinner.hide()
      },
      error => {
        console.log(error)
        this.spinner.hide()
      }
    )
  }

  PrintCertRenta(pagare) {
    this.estadoPagare = null
    this.spinner.show()
    this._userService.httpPost('getCertRentaFsv', { pagare: pagare }).subscribe(
      resp => {
        console.log(resp)
        const linkSource = `data:application/pdf;base64,${resp.details}`;
        const downloadLink = document.createElement("a");
        const fileName = "CertRenta" + pagare + ".pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this.spinner.hide()
      },
      error => {
        console.log(error)
        this.spinner.hide()
      }
    )
  }

  scrollTOElement = (element, offsetParam?, speedParam?) => {
    const toElement = $(element);
    const focusElement = $(element);
    const offset = offsetParam * 1 || 200;
    const speed = speedParam * 1 || 500;
    $('html, body').animate({
      scrollTop: toElement.offset().top + offset
    }, speed);
    if (focusElement) {
      $(focusElement).focus();
    }
  }

  decodeUrl(string) {
    return this._userService.sanitize(string, 'resourceUrl')
  }


}
